"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montecastrilli": {
    "04a507da": [{
      "hkey": "5496bdc1",
      "slug": "castel-dell-aquila",
      "name": "Castel dell'Aquila",
      "primary": true,
      "skipSearch": false
    }],
    "castel-dell-acquila": [{
      "hkey": "5496bdc1",
      "slug": "castel-dell-aquila",
      "name": "Castel dell'Aquila",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;